import { Switch } from '@payfit/midnight/dist/Switch';
import React, { useEffect } from 'react';

import { classNames } from '../../utils/style';
import { useParams } from '../../utils/useParams';
import { toBoolean } from '../../utils/toBoolean';
import { DefaultBsComponent } from '../../types/module';

import { Box } from './Box';

export interface BoxToggleProps extends DefaultBsComponent {
  name: string;
  initialValue?: boolean;
}
export const BoxToggle = ({ name, initialValue, children }: BoxToggleProps) => {
  const [params, setParams] = useParams();

  useEffect(() => {
    if (
      initialValue &&
      !params?.[name] &&
      initialValue !== toBoolean(params?.[name])
    )
      setParams(name, initialValue.toString());
  }, [initialValue, name, params, setParams]);

  return (
    <Box className={classNames('flex')}>
      <div className="w-full">{children}</div>
      <Switch
        label=""
        initialValue={initialValue}
        hideLabel={true}
        onChange={(value: boolean) => {
          setParams(name, value.toString());
        }}
        value={toBoolean(params?.[name])}
      />
    </Box>
  );
};
